import { observer } from "mobx-react";

import Header from "../components/Header";

const IndexPage = observer(() => {
  return (
    <div className="navbar" style={{ display: "flex", height: "100%" }}>
      <Header />
    </div>
  );
});

export default IndexPage;
